import Vue from 'vue';

export class RelationshipUtils {
  static isRelationship(record) {
    return Boolean(record.entityA);
  }

  static selectFromEntity(entity, relationships) {
    return relationships.filter((relationship) => {
      return (
        relationship.entityA === entity.id ||
        relationship.entityB === entity.id
      );
    });
  }

  static selectOrder(record, entity) {
    if (!RelationshipUtils.isRelationship(record)) {
      return Number(record.order || 0);
    }

    if (record.entityA === entity.id) {
      return Number(record.orderA || 0);
    }

    if (record.entityB === entity.id) {
      return Number(record.orderB || 0);
    }

    return null;
  }

  static setOrder(record, entity, order) {
    if (!RelationshipUtils.isRelationship(record)) {
      Vue.set(record, 'order', order);
    }

    if (record.entityA === entity.id) {
      Vue.set(record, 'orderA', order);
    }

    if (record.entityB === entity.id) {
      Vue.set(record, 'orderB', order);
    }
  }
}
